import { TableCell, TableHead, TableRow, TableSortLabel } from "@material-ui/core";

const SrHd = ({ sort, sort_by, createSortHandler }) => {
	const sortLabel = (key, name) => (
		<TableSortLabel
			active={sort === key}
			direction={sort === key ? sort_by : 'asc'}
			onClick={() => createSortHandler(key)}
		>
			{name}
		</TableSortLabel>
	);

	return (
		<TableHead className="engine-module-table">
			<TableRow>
				<TableCell colSpan={8}></TableCell>
				<TableCell colSpan={1}></TableCell>
				<TableCell colSpan={3} align="center">Repair Compliance</TableCell>
				<TableCell></TableCell>
				<TableCell colSpan={3} align="center">Last Done</TableCell>
				<TableCell></TableCell>
				<TableCell></TableCell>
			</TableRow>
			<TableRow>
				<TableCell style={{ minWidth: '140px' }}>Action(s)</TableCell>
				<TableCell style={{ minWidth: '130px' }}>{sortLabel('ata_chapter', 'ATA Chapter')}</TableCell>
				<TableCell style={{ minWidth: '160px' }}>{sortLabel('repair_ref_number', 'Repair Ref No.')}</TableCell>
				<TableCell style={{ minWidth: '130px' }}>{sortLabel('repair_type', 'Repair Type')}</TableCell>
				<TableCell style={{ minWidth: '200px' }}>{sortLabel('repair_description', 'Repair Description')}</TableCell>
				<TableCell style={{ minWidth: '160px' }}>{sortLabel('repeat_inspection', 'Repair Inspection')}</TableCell>
				<TableCell style={{ minWidth: '150px' }}>{sortLabel('repair_location', 'Repair Location')}</TableCell>
				<TableCell style={{ minWidth: '140px' }}>{sortLabel('repair_detail', 'Repair Detail')}</TableCell>
				<TableCell style={{ minWidth: '190px' }}>{sortLabel('repair_compliance_ref', 'Repair Compliance Ref')}</TableCell>
				<TableCell style={{ minWidth: '120px' }}>{sortLabel('repair_compliance_date', 'Date')}</TableCell>
				<TableCell style={{ minWidth: '90px' }}>{sortLabel('repair_compliance_tsn', 'TSN')}</TableCell>
				<TableCell style={{ minWidth: '90px' }}>{sortLabel('repair_compliance_csn', 'CSN')}</TableCell>
				<TableCell style={{ minWidth: '160px' }}>{sortLabel('repair_compliance_date', 'Repair Next Due')}</TableCell>
				<TableCell style={{ minWidth: '120px' }}>{sortLabel('last_done_date', 'Date')}</TableCell>
				<TableCell style={{ minWidth: '90px' }}>{sortLabel('last_done_fh', 'FH')}</TableCell>
				<TableCell style={{ minWidth: '90px' }}>{sortLabel('last_done_fc', 'FC')}</TableCell>
				<TableCell style={{ minWidth: '200px' }}>Remarks</TableCell>
				<TableCell style={{ minWidth: '110px' }}>Attachments</TableCell>
			</TableRow>
		</TableHead>
	);
};

export default SrHd;
